<template>
  <div class="alertTrend-container">
    <div class="rangeContainer">
      <simple-select
        :options="rangeOptions"
        :autoSelect="false"
        :label-in-value="false"
        v-model="currentRange"
      ></simple-select>
    </div>
    <a-spin :spinning="loading">
      <div v-if="trendData.length" style="padding: 10px">
        <line-chart
          chartId="alert-history-trend-chart"
          legendPosition="top"
          colorType="name"
          :chartData="trendData"
          :colors="[redColor, orangeColor, blueColor, '#38D3FA']"
          :height="268"
          :showArea="true"
          :legendOptions="{
            position: 'top',
            offsetY: 0
          }"
        ></line-chart>
      </div>
      <div v-else style="position: relative; overflow: hidden;">
        <empty-component
          :body-style="{
            height: '186px',
            marginTop: '44px'
          }"
          :description-style="{
            marginTop: '-32px'
          }"
        ></empty-component>
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import { getAlertTrend } from '@/api/alert.js'
import { alertSeverities, blueColor, orangeColor, redColor } from '@/utils/const.js'
import SimpleSelect from '@/components/select/SimpleSelect'
import LineChart from '@/components/chart/LineChart.vue'
import EmptyComponent from '@/components/EmptyComponent.vue'

export default {
  name: 'AlertTrend',
  components: {
    SimpleSelect,
    LineChart,
    EmptyComponent
  },
  data () {
    const rangeOptions = [
      { label: '近 7 日', value: 'week' },
      { label: '近 15 日', value: 'half_month' },
      { label: '近 30 日', value: 'month' }
    ]
    return {
      blueColor,
      orangeColor,
      redColor,
      alertSeverities,
      rangeOptions,
      currentRange: 'half_month',
      trendData: [],
      loading: false
    }
  },
  computed: {
    params () {
      if (this.currentRange === 'week') {
        return {
          datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
          datetime_to: moment().format('YYYY-MM-DD HH:mm'),
          trend_of: 'severity'
        }
      }
      if (this.currentRange === 'month') {
        return {
          datetime_from: moment().subtract(30, 'day').format('YYYY-MM-DD HH:mm'),
          datetime_to: moment().format('YYYY-MM-DD HH:mm'),
          trend_of: 'severity'
        }
      }
      return {
        datetime_from: moment().subtract(14, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        trend_of: 'severity'
      }
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      getAlertTrend(this.params).then(res => {
        const data = res.data
        if (data.total) {
          const dataList = []
          const dateList = []
          data.data.forEach(item => {
            dateList.push(item.date)
          })
          for (const item of new Set(dateList)) {
            const split = item.split('-')
            const date = split[1] + '-' + split[2]

            dataList.push(...this.alertSeverities.map(severity => {
              const value = data.data.find(d => d.date === item && d.name === severity)
              return {
                date,
                name: this.$t(`alert_severity.${severity}`),
                value: value ? value.value : 0
              }
            }))
          }
          this.trendData = dataList
        } else {
          this.trendData = []
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    params () {
      this.fetch()
    }
  }
}
</script>

<style lang="less" scoped>
.alertTrend-container {
  position: relative;
  height: 280px;

  .rangeContainer {
    position: absolute;
    right: 0px;
    top: -18px;
    z-index: 999;
  }
}
</style>
